<template>
  <v-card class="no-border main-card fill-height">
    <v-card-text class="fill-height">
      <div class="fill-height">
        <h2 class="title mb-32 pt-40 text-xs-center">
          Exchange settings
        </h2>
        <v-layout row wrap>
          <v-flex class="xs12 md5 lg5">
            <v-card class="thin-border fill-height" style="height: 100%;">
              <v-layout row wrap>
                <v-flex class="xs12 md12 lg12">
                  <v-switch
                    v-model="tradeEngineEnabled"
                    :label="`Enabled`"
                    :disabled="api_form.api_key_first5 === ''"
                    class="switch px-4 pt-3"
                  ></v-switch>
                  <v-switch
                    v-if="exchange === 'Binance'"
                    v-model="doAutoBuyBNB"
                    class="switch px-4 mt-0"
                    ><template slot="label">
                      Autobuy BNB
                      <v-icon
                        class="pl-1 vertical-align-middle icon-for-information"
                        @click="
                          e => {
                            infoAlert(
                              'Auto buy BNB',
                              'When this option is enabled, the bot will attempt to maintain a small amount of BNB in your wallet so the fees can be paid with that (if enabled on the exchange).'
                            );

                            e.stopPropagation();
                          }
                        "
                        >fa-info-circle</v-icon
                      >
                    </template></v-switch
                  >
                  <v-switch
                    v-if="exchange === 'Huobi'"
                    v-model="doAutoBuyHT"
                    class="switch px-4 mt-0"
                    ><template slot="label">
                      Autobuy HT
                      <v-icon
                        class="pl-1 vertical-align-middle icon-for-information"
                        @click="
                          e => {
                            infoAlert(
                              $t('information.settings_auto_buy_ht.title'),
                              $t('information.settings_auto_buy_ht.description')
                            );

                            e.stopPropagation();
                          }
                        "
                        >fa-info-circle</v-icon
                      >
                    </template></v-switch
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex class="xs12 md7 lg7">
            <v-card class="thin-border pa-4 fill-height" style="padding-bottom: 8px !important;">
              <v-flex v-if="api_key_first5" class="status-description">
                Current API key: {{ api_key_first5 }}******
              </v-flex>
              <v-text-field
                v-model="api_form.api_key"
                label="API key"
                name="api_key"
                value="API key"
                autocomplete="off"
              ></v-text-field>
              <v-text-field
                v-model="api_form.api_secret"
                label="API secret"
                name="api_secret"
                value="API secret"
                autocomplete="off"
                :type="type"
              >
                <template v-slot:append>
                  <img
                    width="24"
                    height="24"
                    :src="password_icon"
                    @click="togglePassword"
                  />
                </template>
              </v-text-field>
              <div class="text-xs-right">
                <v-btn
                  color="primary"
                  dark
                  class="mx-0 my-3"
                  @click="updateApiSettings"
                  >Update API settings</v-btn
                >
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.fill-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.theme--light >>> input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  background-color: #ffffff !important;
}
.theme--light >>> input:-webkit-autofill{
  -webkit-text-fill-color: #103a84 !important;
}
.theme--light .divider {
  color: #e6efff !important;
  border-color: #e6efff !important;
}
.theme--light .main-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.theme--light .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
.theme--light .thin-border {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: none !important;
}
.theme--light .status-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #7395d0;
}
.theme--light .status-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #103a84;
  padding-bottom: 24px !important;
}
.theme--light .switch >>> .v-label {
  color: #103a84;
}
.theme--light >>> .v-label {
  color: #b8d2ff;
}
>>> .theme--light.v-input:not(.v-input--is-disabled) input,
>>> .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #103a84;
}
>>> .theme--light .v-input__slot::before {
  border-color: #b8d2ff !important;
}
>>> .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  width: 196px;
  height: 44px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}

.theme--dark .divider {
  color: #303030 !important;
  border-color: #303030 !important;
}
.theme--dark .main-card {
  background: #212121;
  box-shadow: none;
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.theme--dark .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #e9e9e9;
}
.theme--dark .thin-border {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: none !important;
  background-color: #212121;
}
.theme--dark .status-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: rgba(235, 235, 245, 0.6);
}
.theme--dark .status-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
  padding-bottom: 24px !important;
}
.theme--dark .switch >>> .v-label {
  color: #e9e9e9;
}
.theme--dark >>> .v-label {
  color: rgba(235, 235, 245, 0.3);
}
>>> .theme--dark.v-input:not(.v-input--is-disabled) input,
>>> .theme--dark.v-input:not(.v-input--is-disabled) textarea {
  color: #e9e9e9;
}
>>> .theme--dark .v-input__slot::before {
  border-color: rgba(235, 235, 245, 0.3) !important;
}
>>> .theme--dark .v-label.v-label--active,
>>> .theme--dark .v-input.v-input--is-focused {
  color: rgba(235, 235, 245, 0.3) !important;
  caret-color: rgba(235, 235, 245, 0.3) !important;
}
.theme--dark >>> input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #212121 inset;
}
.theme--dark >>> input:-webkit-autofill {
  -webkit-text-fill-color: #e9e9e9 !important;
}
</style>

<script>
import swal from "sweetalert2";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  props: ["exchange"],
  data() {
    return {
      api_key_first5: "",
      api_form: {
        api_key: "",
        api_secret: ""
      },
      do_auto_buy_bnb: false,
      do_auto_buy_ht: false,
      trade_engine_on: false,
      backend_status: {
        message: ""
      },
      type: "password"
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    }),
    themeMode: function() {
      return this.themeDark ? "dark" : "light";
    },
    password_icon: function() {
      return this.type === "password"
        ? "/img/eye-icon-" + this.themeMode + ".svg"
        : "/img/eye-open-icon-" + this.themeMode + ".svg";
    },
    tradeEngineEnabled: {
      get: function() {
        return this.trade_engine_on;
      },
      set: async function(value) {
        try {
          await axios.put("/api/v1/settings/toggle-trade-engine-status", {
            exchange: this.exchange,
            status: value
          });
        } catch (error) {
          swal({
            title: "API keys error",
            text: error.response.data,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });

          this.trade_engine_on = !value;
          return false;
        }
      }
    },
    doAutoBuyBNB: {
      get: function() {
        return this.do_auto_buy_bnb;
      },
      set: async function(value) {
        try {
          await axios.put("/api/v1/settings/toggle-auto-acquire-bnb", {
            status: value
          });
        } catch (error) {
          swal({
            title: "Error",
            text: "Error setting auto buy BNB",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });

          this.do_auto_buy_bnb = !value;
          return false;
        }
      }
    },
    doAutoBuyHT: {
      get: function() {
        return this.do_auto_buy_ht;
      },
      set: async function(value) {
        try {
          await axios.put("/api/v1/settings/toggle-auto-acquire-ht", {
            status: value
          });
        } catch (error) {
          swal({
            title: "Error",
            text: "Error setting auto buy BNB",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });

          this.do_auto_buy_bnb = !value;
          return false;
        }
      }
    }
  },
  mounted: async function() {
    axios.get("/api/v1/settings/api-key/" + this.exchange).then(res => {
      if (res.data.pivot) {
        // We have some settings found for this exchange
        this.api_key_first5 = res.data.pivot.api_key_first5;
      }
    });
    axios
      .get("/api/v1/settings/trade-engine-status/" + this.exchange)
      .then(res => {
        this.trade_engine_on = res.data.trade_engine_on;
      });
    axios
      .get("api/v1/settings/user-backend-status/" + this.exchange)
      .then(res => {
        this.backend_status.message = res.data.status_message;
      });

    if (this.exchange === "Binance") {
      axios.get("/api/v1/settings/auto-acquire-bnb-status").then(res => {
        this.do_auto_buy_bnb = res.data;
      });
    }

    if (this.exchange === "Huobi") {
      axios.get("/api/v1/settings/auto-acquire-ht-status").then(res => {
        this.do_auto_buy_ht = res.data;
      });
    }
  },
  methods: {
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    updateApiSettings: async function() {
      // do api call
      try {
        const { data } = await axios.put("/api/v1/settings/api-key", {
          api_key: this.api_form.api_key,
          api_secret: this.api_form.api_secret,
          trade_engine_on: this.trade_engine_on,
          exchange_name: this.exchange
        });

        this.api_key_first5 = this.api_form.api_key.slice(0, 5);

        // dispatch method
        swal({
          title: "API keys updated",
          text: data,
          showConfirmButton: false,
          showCloseButton: true,
          showCancelButton: false,
          customClass: this.themeDark ? "swal-type-warning-dark" : "swal-type-warning",
          imageUrl: "/img/popup_img_warning.png",
          imageHeight: 48,
          imageWidth: 48
        });

        await this.$store.dispatch("auth/fetchUser");
      } catch (error) {
        swal({
          title: "API keys error",
          text: error.response.data,
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        return false;
      }
    },
    togglePassword() {
      this.type = this.type === "password" ? "text" : "password";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/settings/ApiForm.vue